import request from '../utils/request';
/**
 * @description: 获取微信二次分享的签名信息
 * @param {*} data 
 */
export function getJsAPI(data) {
  return request({
    url: '/api/weixin/getJsAPI',
    method: 'post',
    params: data,
  })
}